import call from './call';
import api from './api';
export default {
    call,api
}